import React from 'react';
import { Dialog, DialogContent, DialogClose } from '@/components/atoms/Dialog';
import { Button } from '@/components/atoms/PcButton';

const PleaseFullfillModal = ({ open, onOpenChange }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent noCloseBtn className="max-w-[350px]">
        <div className="flex w-full flex-col items-center justify-center space-y-4">
          <h2 className="Title3S18">택배사와 운송장 번호를 먼저 채워주세요</h2>

          <DialogClose asChild>
            <Button variant="" className="h-[44px] w-full flex-1">
              확인
            </Button>
          </DialogClose>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PleaseFullfillModal;
